exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-info-container {\n  width: 92%;\n  margin: 0 auto;\n}\n\n\n.product-info-entry {\n  border-bottom: 1px solid #dddddd;\n  margin-bottom: 20px;\n}\n\n.product-info-entry:last-child {\n\n}\n\n.product-info-entry:nth-last-child(2) {\n  border: 0;\n}\n\n.delete-button {\n  width: 100%;\n  text-align: right;\n  padding: 10px 5px 0 0;\n  font-size: 20px;\n}\n\n.delete-button i {\n  cursor: pointer;\n}\n\n.delete-button i:hover {\n  opacity: .5;\n}\n\n.left-input-box {\n  padding-left: 0;\n  padding-right: 10px\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/new-simulation/product-information/product-information.component.css
// module id = ../../../../../src/app/components/new-simulation/product-information/product-information.component.css
// module chunks = main